module.exports = __webpack_public_path__ + "img/curved-rail-vertical-left-bottom-stone-path-background.bd2f7d40.png";